import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";
import html2Pdf from "../../lib/html2pdf";
import request from "@/lib/request/request";
import dayjs from "dayjs";
import { CompanyConfig } from "@/lib/common/acm";
import Loading from "../../components/loading.vue";
import ScoreList from "./score-list";
import {
  AI,
  Answer,
  Candidate,
  CandidateResult,
  MiddleInfo,
  Param
} from "@/lib/model/exam/result";
import { floor, reduce } from "lodash";

const RoseRadius0 = 20;
const RoseRadius1 = 60;
//饼图用色
const colorList = [
  "#4CDE99",
  "#FDC151",
  "#33DFE4",
  "#8851FD",
  "#33B1FF",
  "#FF9245",
  "#FD5151",
  "#BDFD51",
  "#516AFD",
  "#B999D4",
  "#51FD84",
  "#FD51B8",
  "#FDFB51",
  "#51FDC5",
  "#E551FD"
  // "#FF7717",
  // "#009EFF",
  // "#A87FC9",
  // "#FDB225",
  // "#00D7DD",
  // "#00D16E"
];
//玫瑰图配置
const echartsRoseOption = {
  // title: {
  //   text: "", //主标题文本
  //   left: "center",
  //   top: "center",
  //   textStyle: {
  //     // fontFamily: "PingFang SC",
  //     fontSize: 36,
  //     fontWeight: "bold",
  //     color: "#000000",
  //     // align: "center"
  //     // lineHeight: 36,
  //   }
  // },
  title: {
    show: false,
    text: "不符合", //主标题文本
    left: "center",
    top: "center",
    textStyle: {
      // fontFamily: "微软雅黑",
      fontSize: 36
      // fontWeight: "bold",
      // color: "",
      // align: "center",
      // lineHeight: 25
    }
  },
  // legend: {
  //   top: "bottom",
  //   data: [
  //     {
  //       name: "data 1",
  //       // 强制设置图形为圆。
  //       icon: "circle",
  //       textStyle: {
  //         color: "blue"
  //       },
  //       itemStyle: {
  //         color: "blue"
  //       }
  //     },
  //     {
  //       name: "data 2",
  //       // 强制设置图形为圆。
  //       icon: "circle",
  //       // 设置文本为红色
  //       textStyle: {
  //         color: "green"
  //       }
  //     },
  //     {
  //       name: "data 4",
  //       // 强制设置图形为圆。
  //       icon: "circle",
  //       // 设置文本为红色
  //       textStyle: {
  //         color: "red"
  //       }
  //     }
  //   ],
  //   itemStyle: {
  //     // color: (d:any)=>{
  //     // }
  //   },

  //   formatter: (name: any) => {
  //     // const data = option.series[0].data;//获取series中的data
  //     // var total = 0;
  //     // var tarValue;
  //     // for (var i = 0, l = data.length; i < l; i++) {
  //     //     total += data[i].value;
  //     //     if (data[i].name == name) {
  //     //         tarValue = data[i].value;
  //     //     }
  //     // }
  //     // var p = ((tarValue / total) * 100);
  //     return "优秀";
  //   }
  // },
  tooltip: {
    formatter: (p: any, d: any) => {
      return `<div class="sunTip" style="background:${p?.data?.itemStyle.color}!important" >${p?.data?.name}：${p?.data?.value}</div>`;
    },
    className: `sunTipBox`
  },
  series: [
    //底层
    {
      show: false,
      name: "维度最大值",
      type: "pie",
      silent: true,
      borderColor: "#fff",
      // borderWidth: [2],
      // radius: [80,250],
      radius: [String(RoseRadius0) + "%", String(RoseRadius1) + "%"],
      // radius:"100%",
      center: ["50%", "50%"],
      roseType: "area",
      itemStyle: {
        borderRadius: [2, 4],
        color: "#F2F7F8",
        borderColor: "#fff",
        borderWidth: [2]
      },
      data: [],
      label: {
        show: true,
        padding: [5, 0, 0, 0],
        // 在文本中，可以对部分文本采用 rich 中定义样式。
        // 这里需要在文本中使用标记符号：
        // `{styleName|text content text content}` 标记样式名。
        // 注意，换行仍是使用 '\n'。
        // formatter: (d: any) => {
        //   return [`${d.name}`, `{b|${d.data.hisScore}}{c|/${d.value}}`].join(
        //     "\n"
        //   );
        // },
        // rich: {
        //   b: {
        //     fontSize: 18,
        //     fontWeight: "bold",
        //     lineHeight: 1,
        //     color: "#111111",
        //     verticalAlign: "top",
        //     align: "left"
        //   },
        //   c: {
        //     fontSize: 12,
        //     fontWeight: "normal",
        //     lineHeight: 17,
        //     color: "#666666",
        //     verticalAlign: "bottom",
        //     align: "left"
        //   }
        // },
        lineHeight: 20,
        color: "#8590A6",
        fontSize: 12,
        overflow: "breakAll",
        width: 2000
      },
      labelLine: {
        show: false,
        length: 0,
        length2: 0,
        lineStyle: {
          color: "red"
        }
      },
      animationType: "scale"
    },
    // 阴影层
    // {
    //   silent: true,
    //   name: "阴影",
    //   type: "pie",
    //   radius: ["15%", "76.53%"],
    //   //每百分之一长度代表的值：per = 外圈最高分 /（外圈外边百分比-外圈内边百分比）；
    //   //内圈外百分比 = 内圈内百分比 +  内圈最高分 / per

    //   center: ["50%", "50%"],
    //   roseType: "area",
    //   data: [
    //     { value: 85, name: "data 1", itemStyle: { color: "#479CFF80" } },
    //     { value: 25, name: "data 2", itemStyle: { color: "#FF548D75" } },
    //     { value: 30, name: "data 1", itemStyle: { color: "#479CFF80" } },
    //     { value: 35, name: "data 4", itemStyle: { color: "#885DEC80" } },
    //     { value: 15, name: "data 5", itemStyle: { color: "#FF548D75" } },
    //     { value: 45, name: "data 6", itemStyle: { color: "#885DEC80" } }
    //   ],

    //   itemStyle: {
    //     // color: "rgba(255, 84, 141, 0.46)",
    //     borderWidth: [0],
    //     shadowColor: "blue",
    //     // opacity:0.4,
    //     shadowBlur: [0],
    //     shadowOffsetX: 0,
    //     shadowOffsetY: 0,
    //     borderRadius: [6, 12],
    //     borderType: "solid"
    //     // borderCap: "square",
    //   },
    //   label: {
    //     show: false,
    //     position: "center"
    //   },

    //   animationType: "scale"
    // },
    //数据层
    {
      silent: false,
      name: "",
      type: "pie",
      radius: [String(RoseRadius0) + "%", String(RoseRadius1) + "%"],
      //每百分之一长度代表的值：per = 外圈最高分 /（外圈外边百分比-外圈内边百分比）；
      //内圈外百分比 = 内圈内百分比 +  内圈最高分 / per

      center: ["50%", "50%"],
      roseType: "area",
      data: [
        {
          value: 80,
          name: "data 1",
          itemStyle: {
            color: "#525FFFFF"
          }
        },
        { value: 20, name: "data 2", itemStyle: { color: "#FF5479FF" } },
        { value: 30, name: "data 1", itemStyle: { color: "#525FFFFF" } },
        { value: 30, name: "data 4", itemStyle: { color: "#885DECFF" } },
        { value: 10, name: "data 5", itemStyle: { color: "#FF5479FF" } },
        { value: 40, name: "data 6", itemStyle: { color: "#885DECFF" } }
      ],
      itemStyle: {
        color: "#525FFFFF",
        borderColor: "#fff",
        borderWidth: [2],
        borderRadius: [2, 4]
        // borderType: "solid"
      },
      label: {
        show: false
      },
      emphasis: {
        scale: true,
        label: {
          show: false
        }
      },
      animationType: "scale"
    }
    //透明层 卡边框
    // {
    //   name: "透明层",
    //   type: "pie",
    //   silent: false,
    //   borderColor: "#fff",
    //   radius: [String(RoseRadius0) + "%", String(RoseRadius1) + "%"],
    //   center: ["50%", "50%"],
    //   roseType: "area",
    //   itemStyle: {
    //     color: "rgba(1,1,1,0)",
    //     borderColor: "#fff",
    //     borderWidth: [1],
    //   },
    //   data: [],
    //   label: {
    //     show: false,
    //   },
    //   labelLine: {
    //     show: false,
    //     length: 0,
    //     length2: 0,
    //   },
    //   emphasis: {
    //     scale: false,
    //     label: {
    //       show: false,
    //     },
    //   },
    //   animationType: "scale",
    // },
  ]
};
//旭日图配置
const echartsSunOption = {
  title: {
    text: "不符合", //主标题文本
    // subtext: "与当前岗位用\n人标准有偏差", //副标题文本
    left: "center",
    top: "center",
    textStyle: {
      fontFamily: "PingFang SC",
      fontSize: 18,
      fontWeight: "bold",
      color: "",
      align: "center",
      lineHeight: 25
    }
    // subtextStyle: {
    //   fontFamily: "PingFang SC",
    //   fontSize: 10,
    //   color: "",
    //   align: "center",
    //   lineHeight: 12,
    //   width: 60,
    // },
  },
  // 图标
  // <span class="iconfont-ai ec-icon">${
  //       p?.data?.isMatch === 1 ? "&#xe62b;" : "&#xe62c;"
  //     }</span>
  tooltip: {
    formatter: (p: any, d: any) => {
      return `<div class="sunTip ${
        p.dataIndex === 0 ? "back" : p?.data?.isMatch === 1 ? "sunTipOk" : ""
      }"> <div class="toolTitle">${p?.data?.name ??
        "显示上级维度"}</div><div>${p?.data?.content ?? ""}</div></div>`;
    },
    className: `sunTipBox`,
    textStyle: {}
  },
  series: {
    type: "sunburst",
    data: [],
    levels: [
      {
        value: 999,
        //返回层
        itemStyle: {
          color: "rgba(1,1,1,0)"
        }
      },
      {
        //第一层数据
        r0: "23%",
        r: "51%",
        label: {
          rotate: "tangential", //文字角度
          color: "#fff"
        },
        itemStyle: {
          borderWidth: 2,
          borderColor: "#fff"
        }
      },
      {
        //第二层数据
        r0: "51%",
        r: "58%",
        label: {
          rotate: "radial", //文字角度
          align: "left",
          position: "outside",
          offset: ["50%", "90%"],
          overflow: "breakAll",
          color: "#666666",
          fontSize: 12
        },
        itemStyle: {
          borderWidth: 2,
          borderColor: "#fff"
        }
      }
    ]
  }
};

@Component({
  components: {
    Loading
  }
})
export default class PaperResultNewPractice extends Vue {
  $refs!: {
    echartsRose: HTMLCanvasElement;
    echartsSun: HTMLCanvasElement;
    echartsL: HTMLCanvasElement;
    echartsR: HTMLCanvasElement;
    ecLD: HTMLCanvasElement;
    ecLong: HTMLCanvasElement;
    bar1: HTMLElement[];
    bar2: HTMLElement[];
    PCvideo: HTMLElement[];
  };
  barLight1 = 0; //进度条刻度 单选
  barLight2 = 0; //进度条刻度 编程
  dataAllReady = false;
  connectCode = "";
  candidate = new Candidate(); //候选人信息 主表
  all = new CandidateResult(); //候选人信息 所有表
  examData: any = { paperScore: 0, score: 0 }; //笔面试报告数据
  AIMessageList: any[] = []; //AI标签
  pdfIng = false; //下载pdf中
  showAiQuestion = true; //ai回答记录展开收起
  showExamQuestion = true; //笔面试记录
  showTT = false;
  fk = "";

  get timeFilter() {
    let t = "";
    const min = Math.floor(this.all.candidateReport.useTimeSecond / 60);
    const sec = this.all.candidateReport.useTimeSecond % 60;
    t += min ? min + "分" : "";
    t += sec ? sec + "秒" : "";
    return t || "0分0秒";
  }

  showAiQuestionParse = true;
  //超越了百分多少候选人
  get scoreRank() {
    const score = this.candidate.score;
    const list = new ScoreList().list;

    const lowerSocreList = list.filter(s => s < score);

    const rank = lowerSocreList.length / list.length;

    return (rank * 100).toFixed(1);
  }
  get getResultText() {
    const s = this.candidate.score;

    return s <= 100 && s >= 80
      ? "表现优秀"
      : s < 80 && s >= 70
      ? "表现良好"
      : s < 70 && s >= 50
      ? "表现一般"
      : "表现欠佳";
  }
  //是否隐藏手机号
  get isHidePhone() {
    return CompanyConfig.getInstance().isHidePhone === 1;
  }
  //是否展示简历链接
  get isShowAttachment() {
    return CompanyConfig.getInstance().isShowAttachment === 1;
  }
  //是否隐藏AI推荐
  get isHideResultAiStar() {
    return CompanyConfig.getInstance().isHideResultAiStar === 1;
  }
  //hr修改小维度
  get showHrChange() {
    return this.all.dimensionReport.find((d: AI) => {
      return d.afterHrChange === 1;
    });
  }
  //心理测评 answer数据
  get mindData() {
    return this.all?.questionAnswerMap?.[106]?.[0]?.answer ?? new Answer();
  }
  //有偏差的维度 心理
  get mindBadData() {
    const t =
      this.all?.questionAnswerMap?.[106]?.[0]?.answer?.psycResult
        ?.newResultList ?? new Answer()?.psycResult?.newResultList;
    const res: any = [];
    t.forEach(d => {
      d.children.forEach(m => {
        if (m.isMatch !== 1) res.push(m);
      });
    });

    return res;
  }
  //全无偏差文案 心理
  get mindNoBadText() {
    const t =
      this.all?.questionAnswerMap?.[106]?.[0]?.answer?.psycResult
        ?.newResultList ?? new Answer()?.psycResult?.newResultList;
    let text = "";
    t.forEach(d => {
      text += d.dimensionName + "、";
    });
    return text.slice(0, -1);
  }
  //突出维度 心理
  get mindGoodData() {
    const t =
      this.all?.questionAnswerMap?.[106]?.[0]?.answer?.psycResult
        ?.newResultList ?? new Answer()?.psycResult?.newResultList;
    const res: any = [];
    t.forEach(d => {
      d.children.forEach(m => {
        if (m.isMatch === 1 && (m.score === 1 || m.score === 10)) {
          res.push(m);
        }
      });
    });
    return res;
  }
  //打气球游戏数据
  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  //极速左右游戏数据
  get gameXi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 2;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  //游戏环节完成
  get gameOver() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return t?.answer?.isAnswered === 1;
  }
  //AI推荐级别
  get AiStar() {
    const star = this.candidate.aiRecommendStatus;
    const text =
      star === 10
        ? "不推荐"
        : star === 20
        ? "一般"
        : star === 30
        ? "推荐"
        : star === 40
        ? "非常推荐"
        : "无";
    return {
      text: text,
      level: star,
      url: require("../../assets/result/st" + star + ".png")
    };
  }
  //笔试得分  目前只有 单选和编程
  get examScore() {
    const res = { t1Score: 0, t1AllScore: 0, t4Score: 0, t4AllScore: 0 }; //兜底结果 总分为0 判为 不存在该类型题
    const examAllQuesiton = this.all?.coderDetail?.paperSections;
    if (!examAllQuesiton) return res;
    examAllQuesiton.forEach((d: any) => {
      if (d.questionType === "1") {
        //单选
        d.questions.forEach((d: any) => {
          res.t1Score += d.answerScore;
          res.t1AllScore += d.score;
        });
      }
      if (d.questionType === "4") {
        //编程
        d.questions.forEach((d: any) => {
          res.t4Score += d.answerScore;
          res.t4AllScore += d.score;
        });
      }
    });
    return res;
  }
  get getAIMessageListGood() {
    return this.AIMessageList.filter(res => {
      return res.messageType === 1;
    });
  }
  get getAIMessageListBad() {
    return this.AIMessageList.filter(res => {
      return res.messageType === 2;
    });
  }
  //计算返回按钮位置
  setFixed() {
    const WH: HTMLElement = this.$refs["full"] as HTMLElement;
    const w = Number(WH?.clientWidth) / 2 - 48 - 420 - 20;
    return w + "px";
  }
  created() {
    document.title = document.location.origin.includes("mianshi.nrpla")
      ? "牛人星球"
      : "海纳AI面试";
  }

  mounted() {
    console.log(document);
    console.log(document.title);

    this.connectCode = this.$route.query.connectCode as string;
    this.open();
  }
  //入口
  open() {
    //确保Ec容器渲染完成
    this.$nextTick(() => {
      //主表
      Candidate.get({ connectCode: this.connectCode })
        .then(res => {
          res.paramList = res.paramList.filter(d => {
            return (
              d.isShow === 1 &&
              (!this.isHidePhone || (this.isHidePhone && d.name !== "手机"))
            );
          });
          this.candidate = res;
          // if (this.candidate?.bgCheckResult?.product?.productId !== 0) {
          //   //购买背调
          //   this.getBG();
          // }
          return CandidateResult.get({ connectCode: this.connectCode }); //所有表
        })
        .then(r => {
          this.all = r;
          this.$nextTick(() => {
            this.examData = r.coderDetail || { paperScore: 0, score: 0 }; //笔试数据
            this.setExamIndex(); //笔试题号
            this.AIMessageList = r.dimensionReportMessage;
            // this.showColorRes(); //色盲结果
            // this.sortInfo(); //个人信息 排序
            this.setEcharts(); //绘制ec
            this.setEchartsOld(r.dimensionReport); //EC
            this.setEchartLD(); //ec
            this.listenVideo(); //视频监听
            //客户引用页面要的高度
            this.sendHeight();
            this.setProgressbar(); //绘制笔面试得分进度条
            this.dataAllReady = true;
          });
        });
    });
  }
  //绘制EC
  setEcharts() {
    //玫瑰图数据
    const dList = this.all.dimensionReport;
    const allData: any = [];
    const scoreData: any = [];

    let allDataMax = 0; //维度总分最大值
    let scoreDataMax = 0; //维度得分最大值
    dList.forEach(d => {
      //维度得分比例
      const percent = Math.round((d.score / d.scoreAll) * 100);
      const color =
        percent >= 80 ? "#525FFFFF" : percent >= 60 ? "#885DECFF" : "#FF548DFF";
      const judge = percent >= 80 ? "良好" : percent >= 60 ? "中等" : "较差";
      //维度满分
      allData.push({ name: d.dimension, value: d.scoreAll, hisScore: d.score });
      //维度得分
      scoreData.push({
        name: d.dimension,
        value: d.score,
        itemStyle: { color: color }
      });
      allDataMax = d.scoreAll > allDataMax ? d.scoreAll : allDataMax;
      scoreDataMax = d.score > scoreDataMax ? d.score : scoreDataMax;
    });
    //计算数据比例
    //每百分之一长度代表的值：per = 外圈最高分 /（外圈外边百分比-外圈内边百分比）；
    //内圈外百分比 = 内圈内百分比 +  内圈最高分 / per
    echartsRoseOption.series[1].radius[1] =
      String(
        (
          RoseRadius0 +
          scoreDataMax / (allDataMax / (RoseRadius1 - RoseRadius0))
        ).toFixed(2)
      ) + "%";
    echartsRoseOption.series[0].data = allData;
    echartsRoseOption.series[1].data = scoreData;
    // echartsRoseOption.series[2].data = allData;// 透明层
    this.fk = String(this.all.candidateReport.score);
    // echartsRoseOption.title.text =
    if (this.$refs.echartsRose) {
      const ecRose = echarts.init(this.$refs.echartsRose);
      ecRose.setOption(echartsRoseOption);
    }

    //旭日图数据
    const d = this.mindData?.psycResult?.newResultList;
    const sunData: any = [];
    d.forEach((d, i) => {
      const R1Data: any = {
        name: d.dimensionName,
        isMatch: d.isMatch,
        children: [],
        content: d.content,
        itemStyle: {
          color: d.isMatch === 1 ? "#525FFFFF" : "#FF5479FF"
        }
      };
      d.children.forEach((m, n) => {
        R1Data.children.push({
          name: m.dimensionName,
          isMatch: m.isMatch,
          value: 1,
          content: m.content,
          itemStyle: {
            color: m.isMatch === 1 ? "#525FFFFF" : "#FF5479FF"
          }
        });
      });
      sunData.push(R1Data);
    });

    echartsSunOption.series.data = sunData;
    //总结果文案
    const bad = this.mindBadData.length;
    echartsSunOption.title.text = bad ? "不符合" : "符合";
    // echartsSunOption.title.subtext = bad
    //   ? "与当前岗位用\n人标准有偏差"
    //   : "与当前岗位\n用人标准匹配";
    echartsSunOption.title.textStyle.color = bad ? "#FF5479FF" : "#525FFF";
    // echartsSunOption.title.subtextStyle.color = bad ? "#FF5479FF" : "#525FFF";

    if (this.$refs.echartsSun) {
      const ecSun = echarts.init(this.$refs.echartsSun);
      ecSun.setOption(echartsSunOption);
    }
  }
  //老版报告页的
  setEchartsOld(r: any) {
    // if (this.atsCvOutId) return;
    if (r.length === 0) return;
    // this.scoreTotal = 0;
    // this.scoreTotalAll = 0;
    this.optionRadar.series[0].data[0].value = [];
    this.optionRadar.radar.indicator = [];
    this.optionPie.series[0].data = [];
    // const middleScoreList: number[] = [];
    r.forEach((d: any, index: number) => {
      //   this.scoreTotal += d.score; // 总得分
      //   this.scoreTotalAll += d.scoreAll; //总分
      this.optionRadar.radar.indicator.push({
        name: d.dimension,
        max: d.scoreAll
      });
      this.optionRadar.series[0].data[0].value.push(d.score > 0 ? d.score : 0); //雷达数据
      // const m =
      //     this.middleInfo.dimensionReportNew?.[index]?.medianScore < 0
      //         ? 0
      //         : this.middleInfo.dimensionReportNew?.[index]?.medianScore;
      // middleScoreList.push(m); //中位数
      this.optionPie.series[0].data.push({
        name: d.dimension,
        value: d.scoreAll
      }); //饼图数据
    });
    // //中位数展示
    // if (this.showMS) {
    //   // eslint-disable-next-line @typescript-eslint/no-this-alias
    //   const that = this;
    //   this.optionRadar.series.push({
    //     name: "考察维度中位分",
    //     type: "radar",
    //     symbol: "circle", //形状
    //     symbolSize: 1, // 拐点的大小
    //     itemStyle: {
    //       color: "#525FFFFF"
    //     },
    //     data: [
    //       {
    //         value: middleScoreList,
    //         name: "维度中位分"
    //       }
    //     ],
    //     lineStyle: { color: "#525FFFFF", width: 1 },
    //     areaStyle: { color: "#525FFF0D", opacity: 0.15 }
    //   });
    //   this.optionRadar.series[0].data[0].name = "维度得分";
    //   this.optionRadar.tooltip = {
    //     appendToBody: true, //起到提前渲染作用 防止float计算距离时会错位
    //     formatter(params: any) {
    //       let t = params.seriesName + `<br/>`;
    //       params.value.forEach((d: any, i: number) => {
    //         t +=
    //           `<span style="display:inline-block;margin:0 8px 3px 3px;border-radius:4px;width:4px;height:4px;background-color:${params.color};"></span>` +
    //           r[i].dimension +
    //           `：<span style="float:right">`;
    //         t +=
    //           params.seriesName === "考察维度中位分"
    //             ? that.middleInfo.dimensionReportNew[i].medianScore +
    //               `</span><br/>`
    //             : r[i].score +
    //               ` (中位分${that.middleInfo.dimensionReportNew[i].medianScore})</span><br/>`;
    //       });
    //       return t;
    //     }
    //   };
    // }

    //AI表格
    // this.AIList = r || [];
    this.$nextTick(() => {
      if (this.$refs.echartsL) {
        const echartsL = echarts.init(this.$refs.echartsL);
        //雷达
        echartsL.setOption(this.optionRadar);
      }
      if (this.$refs.echartsR) {
        //饼图
        const echartsR = echarts.init(this.$refs.echartsR);
        echartsR.setOption(this.optionPie);
      }
    });
  }
  //得分EC
  setEchartLD() {
    this.nextEC();
    if (!this.$refs.ecLD) return;
    const echart = echarts.init(this.$refs.ecLD);
    if (echart) {
      this.ecOptionLD.xAxis[0].data = [];
      this.ecOptionLD.series[0].data = [];
      this.ecOptionLD.series[1].data = [];
      this.all.answerList.forEach((it, i) => {
        this.ecOptionLD.xAxis[0].data.push("题目" + Number(i + 1));
        this.ecOptionLD.series[0].data.push({ value: it.score });
        this.ecOptionLD.series[1].data.push({
          value: this.all.questionList[i].score,
          myScore: it.score
        });
      });
      setTimeout(() => {
        echart.clear();
        echart.setOption(this.ecOptionLD);
        window.addEventListener("resize", () => {
          echart.resize();
        });
      }, 1000);
    }
  }
  nextEC() {
    if (!this.$refs.ecLong) return;
    const echart = echarts.init(this.$refs.ecLong as any);
    if (echart) {
      // this.ecOptionLong.xAxis[0].data = this.timeData.byTimeDuration.headers;
      // this.ecOptionLong.series[0].data = this.timeData.byTimeDuration.row;
      echart.setOption(this.ecOptionLong);
      window.addEventListener("resize", () => {
        echart.resize();
      });
    }
  }

  //笔试得分 进度条
  setProgressbar() {
    //单选
    const t1 = this.examScore.t1Score / this.examScore.t1AllScore || 0; //总分为0 视为 无此题型 得0%
    this.barLight1 = Math.max(0, Math.round(t1 * 50) - 1);
    this.$nextTick(() => {
      if (this.$refs?.bar1?.[0]) {
        (this.$refs.bar1[0] as any)?.setAttribute(
          "percentNum",
          String(Math.floor(t1 * 100)) + "%"
        );
      }
    });
    //编程
    const t4 = this.examScore.t4Score / this.examScore.t4AllScore || 0;
    this.barLight2 = Math.max(0, Math.round(t4 * 50) - 1);
    this.$nextTick(() => {
      if (this.$refs?.bar2?.[0]) {
        (this.$refs.bar2[0] as any)?.setAttribute(
          "percentNum",
          String(Math.floor(t4 * 100)) + "%"
        );
      }
    });
  }

  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }
  //自动暂停其他视频
  listenVideo() {
    //滚动监听
    this.$nextTick(() => {
      window.addEventListener("scroll", (e: any) => {
        this.handleScroll();
      });
    });
    const v: any = this.$refs.PCvideo;
    if (!v) return;
    v.forEach((video: any) => {
      video.addEventListener("play", (d: any) => {
        v.forEach((item: any) => {
          if (d.currentTarget.id !== item.id) {
            item.pause();
          }
        });
      });
    });
  }
  //填空题答案
  blankAnswer(answer: any) {
    let t = ``;
    answer.blanks.forEach((d: any, i: number) => {
      t += `${i + 1}.（${d}）    `;
    });
    return t;
  }
  //跳转
  toScroll(to: string) {
    if (!this.$refs[to] || this.pdfIng) {
      return;
    }
    (this.$refs[to] as HTMLElement).scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
  // 下拉区域
  handleScroll() {
    const rect = (this.$refs["toMind"] as HTMLElement)?.getBoundingClientRect();
    if (rect?.top < 0) {
      this.showTT = true;
    } else {
      this.showTT = false;
    }
  }

  //下载pdf
  downPDF() {
    if (this.pdfIng) return false;
    this.showAiQuestion = true;
    this.showExamQuestion = true;
    this.pdfIng = true;
    this.$nextTick(() => {
      const downloadBtn: HTMLElement = document.getElementById(
        "download"
      ) as HTMLElement;
      if (downloadBtn) downloadBtn.style.visibility = "hidden";
      const resultBox: HTMLElement = document.getElementById(
        "full"
      ) as HTMLElement;
      html2Pdf.downloadPDF(
        resultBox,
        "面试报告-" + this.candidate.showName,
        false
      );
      if (downloadBtn) downloadBtn.style.visibility = "visible";
      setTimeout(() => {
        this.pdfIng = false; //延下按钮
      }, 2000);
    });
  }
  //头像占位
  defImg(event: any) {
    this.candidate.photoUrl = "";
    const img = event.srcElement;
    img.onerror = null; //防止闪图
  }
  //客户要的高度
  sendHeight() {
    const t = setInterval(() => {
      if (document.readyState === "complete") {
        window.parent.postMessage(
          { height: document.getElementById("full")?.scrollHeight },
          "*"
        );
        clearInterval(t);
      }
    }, 500);
  }
  //笔试-题号
  setExamIndex() {
    if (!this?.examData?.paperSections) {
      //无数据
      return;
    }
    let qIndex = 1;
    this.examData.paperSections.forEach((d: any) => {
      d.questions.forEach((q: any) => {
        q.qIndex = qIndex;
        qIndex++;
      });
    });
  }
  //笔试-选择题回答
  getHisAnswer(q: any) {
    if (!q) return;
    const answerList = q?.answerContent.split(",");
    const resList: string[] = [];
    q?.answers.forEach((d: any, i: number) => {
      answerList.forEach((m: any) => {
        if (d.id === m) resList.push(String.fromCharCode(65 + i));
      });
    });
    return resList.join(",");
  }
  //笔试-填空回答
  getTKanswer(t: any) {
    return t.split("@#^#@");
  }
  //笔试交时间 格式化
  get showTime() {
    if (!this.examData.handTime) return "--";
    return (
      dayjs(
        new Date(
          Number(
            Number(this.examData.startTime)
              ? this.examData.handTime
              : this.examData.expireTime
          ) * 1000
        )
      ).format("YYYY-MM-DD HH:mm:ss") ?? "--"
    );
  }
  get showTimeLong() {
    if (!this.examData.handTime) return "--";
    if (!Number(this.examData.startTime)) return "0分0秒";
    const long =
      Number(this.examData.handTime) - Number(this.examData.startTime);
    return Math.floor(long / 60) + "分" + Math.floor(long % 60) + "秒";
  }

  cpLink() {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = document.URL;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  //Ec雷达配置
  optionRadar = {
    tooltip: {},
    legend: {
      left: "right",
      top: "bottom",
      orient: "vertical", //排列方向 horizontal
      textStyle: {
        color: "#8590A6",
        fontSize: 9
      },
      itemHeight: 10,
      itemWidth: 10,
      data: ["维度得分", "维度中位分"]
    },
    radar: {
      shape: "circle",
      splitNumber: 5, //几段线
      nameGap: 5, //名称和轴的距离
      radius: "65%",
      splitArea: { areaStyle: { color: ["#FFFFFF"] } }, //背景区域
      splitLine: { lineStyle: { color: ["#EAEDF7"] } }, //极坐标
      axisLine: { lineStyle: { color: "#EAEDF7" } }, //轴线
      name: {
        textStyle: {
          fontSize: "9",
          fontWeight: 400,
          fontFamily: "PingFangSC-Regular",
          color: "#8590A6"
        }
      },
      indicator: [
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 }
      ]
    },
    series: [
      {
        name: "考察维度得分",
        type: "radar",
        symbol: "circle", //形状
        symbolSize: 2, // 拐点的大小
        itemStyle: {
          color: "#FF5FA6FF"
        },
        data: [
          {
            value: [0],
            name: ""
          }
        ],
        lineStyle: { color: "#FF5FA6FF", width: 1 },
        areaStyle: { color: "#FF5FA626", opacity: 0.15 }
      }
    ]
  };
  //Ec饼状图配置
  optionPie = {
    tooltip: {
      trigger: "item",
      formatter: "{b}：{d}%"
    },
    series: [
      {
        name: "考察维度权重",
        type: "pie",
        clockwise: false, //是否顺时针
        color: colorList,
        radius: ["35%", "60%"],
        label: {
          show: true,
          fontSize: 9,
          lineHeight: 12,
          color: "#8590A6",
          formatter: "{b}" + "\n" + "{d}%",
          position: "left"
        },
        itemStyle: { borderWidth: 1, borderColor: "#FFFFFF" },
        emphasis: {
          scaleSize: 2,
          focus: "self",
          //聚焦态
          label: {
            show: true,
            fontSize: "9px",
            fontWeight: "bold"
          }
        },
        labelLine: {
          show: false,
          length: 10, //两段线 控制文字位置
          length2: 0
        },
        data: [
          { value: 200, name: "A权重占比" },
          { value: 400, name: "B权重占比" },
          { value: 100, name: "C权重占比" },
          { value: 484, name: "D权重占比" },
          { value: 300, name: "E权重占比" },
          { value: 300, name: "F权重占比" }
        ]
      }
    ]
  };

  ecOptionLD = {
    grid: {
      left: "3%",
      right: "3%",
      bottom: "5%",
      top: "12%",
      containLabel: true
    },
    color: ["#525fff", "#D9DCE6FF"],
    tooltip: {
      show: false,
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985"
        }
      }
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        data: [""],
        axisTick: {
          inside: true, //刻度
          lineStyle: {
            color: "#f3f5f7"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#D9DCE6FF"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#4F5561FF"
          }
        }
      }
    ],
    yAxis: [
      {
        type: "value",
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#D9DCE6FF"
          }
        }
      }
    ],
    series: [
      {
        name: "本题得分",
        type: "bar",
        // stack: "Total",
        smooth: false,
        // barWidth: 30, // 柱图宽度
        barMaxWidth: 30, // 最大宽度
        lineStyle: {
          width: 1.5,
          cap: "round"
        },
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [3, 3, 0, 0]
          }
        },
        data: [{}],
        animationEasing: "bounceOut",
        animationDuration: 1500,
        z: 2,
        silent: true
      },
      {
        silent: true,
        name: "本题分值",
        type: "bar",
        // stack: "Total",
        barGap: "-100%", //移动第二个柱子的位置实现重叠
        z: "1", //改变这根柱子的层级使这根柱子在下面
        smooth: false,
        // barWidth: 30, // 柱图宽度
        barMaxWidth: 30, // 最大宽度
        lineStyle: {
          width: 1.5,
          cap: "round"
        },
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [3, 3, 0, 0]
          }
        },
        label: {
          show: true,
          position: "top",
          color: "#4F5561",
          fontSize: 12,
          formatter: (params: any, ot: any) => {
            return params.data.myScore + "/" + params.value;
          }
        },

        data: [{}],
        animationEasing: "bounceOut",
        animationDuration: 1500
      }
    ]
  };

  ecOptionLong = {
    grid: {
      left: "3%",
      right: "3%",
      bottom: "5%",
      top: "8%",
      containLabel: true
    },
    color: ["#525fff"],
    tooltip: {
      show: false,
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985"
        }
      }
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        data: [
          "0-10",
          "11-20",
          "21-30",
          "31-40",
          "41-50",
          "51-60",
          "61-70",
          "71-80",
          "81-90",
          "91-100"
        ],
        axisTick: {
          inside: true, //刻度
          lineStyle: {
            color: "#f3f5f7"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#D9DCE6FF"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#4F5561FF"
          }
        }
      }
    ],
    yAxis: [
      {
        type: "value",
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#D9DCE6FF"
          }
        }
      }
    ],
    series: [
      {
        name: "候选人人数",
        type: "bar",
        stack: "Total",
        smooth: false,
        barWidth: 30, // 柱图宽度
        // barMaxWidth: 30, // 最大宽度
        lineStyle: {
          width: 1.5,
          cap: "round"
        },
        itemStyle: {
          normal: {
            //柱形图圆角，初始化效果
            barBorderRadius: [3, 3, 0, 0]
          }
        },

        showSymbol: true, //拐点
        symbol: "circle",
        symbolSize: 7,
        areaStyle: {
          opacity: 0,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(82, 95, 255, 0.13)"
            },
            {
              offset: 0.8,
              color: "rgba(82, 95, 255, 0)"
            }
          ])
        },
        emphasis: {
          focus: "series"
        },
        data: [
          this.getScoreListNumber(0, 10),
          this.getScoreListNumber(11, 20),
          this.getScoreListNumber(21, 30),
          this.getScoreListNumber(31, 40),
          this.getScoreListNumber(41, 50),
          this.getScoreListNumber(51, 60),
          this.getScoreListNumber(61, 70),
          this.getScoreListNumber(71, 80),
          this.getScoreListNumber(81, 90),
          this.getScoreListNumber(91, 100)
        ],
        animationEasing: "bounceOut",
        animationDuration: 1500
      }
    ]
  };
  //假数据区间人数
  getScoreListNumber(low: number, high: number) {
    const list = new ScoreList().list.filter(i => {
      return i >= low && i <= high;
    });
    return list.length;
  }
}
